export default (store, { extraInfo = {} }) => {
  if (
    extraInfo.data &&
    extraInfo.data.userId &&
    parseInt(extraInfo.data.userId, 10) === store.state.user.id
  ) {
    store.dispatch('user/changeNotification'); // app.GetLoggedInUser()
  }
};
